(function () {
const LAST_VISIT_KEY = 'custom';
const SESSION_KEY = 'custom';
const PREVIOUS_VISIT_KEY = 'custom';

function getAudience() {
try {
const existingAudience = sessionStorage.getItem(SESSION_KEY);
const existingPrevious = Number(sessionStorage.getItem(PREVIOUS_VISIT_KEY) || 0);
if (existingAudience) {
return { audience: existingAudience, previousVisit: existingPrevious };
}

  const previousVisit = Number(localStorage.getItem(LAST_VISIT_KEY) || 0);
  const sixMonths = 180 * 24 * 60 * 60 * 1000;
  const returning = previousVisit > 0 && Date.now() - previousVisit < sixMonths;
  const audience = returning ? 'returning' : 'first';

  sessionStorage.setItem(SESSION_KEY, audience);
  sessionStorage.setItem(PREVIOUS_VISIT_KEY, String(previousVisit));
  localStorage.setItem(LAST_VISIT_KEY, String(Date.now()));
  return { audience: audience, previousVisit: previousVisit };
} catch (error) {
  return { audience: 'first', previousVisit: 0 };
}

}

const visitor = getAudience();

function bindFastInteractions() {
const documentElement = document.documentElement;
if (documentElement.dataset.customFastInteractions === 'true') return;
documentElement.dataset.customFastInteractions = 'true';

const interactiveSelector = 'a[href], button:not([disabled]), summary, label[for], [role="button"]';
let activeTap = null;

function getInteractiveTarget(eventTarget) {
  if (!(eventTarget instanceof Element)) return null;
  const target = eventTarget.closest(interactiveSelector);
  if (!target || target.matches('[aria-disabled="true"], [data-custom-no-fast-tap]')) return null;
  if (target.closest('[inert]')) return null;
  return target;
}

function clearActiveTap() {
  if (activeTap?.target) activeTap.target.classList.remove('custom-fast-tap-active');
  activeTap = null;
}

document.addEventListener('pointerdown', function (event) {
  if (!event.isPrimary || event.button !== 0) return;
  const target = getInteractiveTarget(event.target);
  if (!target) return;

  clearActiveTap();
  activeTap = {
    target: target,
    pointerId: event.pointerId,
    pointerType: event.pointerType,
    startX: event.clientX,
    startY: event.clientY,
    startedAt: Date.now(),
    cancelled: false
  };
  target.classList.add('custom-fast-tap-active');
}, { capture: true, passive: true });

document.addEventListener('pointermove', function (event) {
  if (!activeTap || activeTap.pointerId !== event.pointerId) return;
  const distanceX = Math.abs(event.clientX - activeTap.startX);
  const distanceY = Math.abs(event.clientY - activeTap.startY);
  if (distanceX > 12 || distanceY > 12) {
    activeTap.cancelled = true;
    activeTap.target.classList.remove('custom-fast-tap-active');
  }
}, { capture: true, passive: true });

document.addEventListener('pointercancel', clearActiveTap, true);
window.addEventListener('pagehide', clearActiveTap);
window.addEventListener('pageshow', clearActiveTap);

document.addEventListener('pointerup', function (event) {
  if (!activeTap || activeTap.pointerId !== event.pointerId) return;

  clearActiveTap();
}, { capture: true, passive: true });

}

function applyAudience() {
const isReturning = visitor.audience === 'returning';
document.body.classList.toggle('custom-returning', isReturning);
document.body.classList.toggle('custom-first-visit', !isReturning);

document.querySelectorAll('[data-custom-new-rail]').forEach(function (rail) {
  const heading = rail.querySelector('[data-custom-dynamic-heading]');
  const firstHeading = rail.dataset.firstHeading || 'New This Week';
  const returningHeading = rail.dataset.returningHeading || 'New Since Your Last Visit';
  const fallbackHeading = rail.dataset.fallbackHeading || firstHeading;
  const items = Array.from(rail.querySelectorAll('[data-custom-published-at]'));

  if (!isReturning || !visitor.previousVisit) {
    if (heading) heading.textContent = firstHeading;
    items.forEach(function (item) { item.hidden = false; });
    return;
  }

  const newlyPublished = items.filter(function (item) {
    return Number(item.dataset.customPublishedAt || 0) > visitor.previousVisit;
  });

  if (newlyPublished.length >= 2) {
    items.forEach(function (item) { item.hidden = newlyPublished.indexOf(item) === -1; });
    if (heading) heading.textContent = returningHeading;
  } else {
    items.forEach(function (item) { item.hidden = false; });
    if (heading) heading.textContent = fallbackHeading;
  }
});

if (isReturning) {
  const priority = document.querySelector('[data-custom-role="priority"]')?.closest('.shopify-section');
  const recent = document.querySelector('[data-custom-role="recently"]')?.closest('.shopify-section');
  if (priority && recent && priority.parentNode === recent.parentNode) {
    recent.insertAdjacentElement('afterend', priority);
  }
}

}

function bindRailButtons(root) {
root.querySelectorAll('[data-custom-scroll]').forEach(function (button) {
if (button.dataset.customBound === 'true') return;
button.dataset.customBound = 'true';
button.addEventListener('click', function () {
const section = button.closest('.custom-section');
const track = section?.querySelector('[data-custom-track]');
if (!track) return;
const direction = button.dataset.customScroll === 'next' ? 1 : -1;
track.scrollBy({ left: track.clientWidth * .82 * direction, behavior: 'smooth' });
});
});
}

function bindComparisons(root) {
root.querySelectorAll('[data-custom-comparison]').forEach(function (comparison) {
const range = comparison.querySelector('input[type="range"]');
if (!range || range.dataset.customBound === 'true') return;
range.dataset.customBound = 'true';
const update = function () {
comparison.style.setProperty('--custom-position', range.value + '%');
};
range.addEventListener('input', update);
update();
});
}

const heroInstances = window.__matrixHeroSliders || (window.__matrixHeroSliders = new WeakMap());

function bindHeroSliders(root) {
const sliders = Array.from(root.querySelectorAll('[data-custom-hero-slider]'));
if (root.matches?.('[data-custom-hero-slider]')) sliders.unshift(root);
sliders.forEach(function (slider) {
const previous = heroInstances.get(slider);
if (previous?.version === 'fixed-text-v2') return;
previous?.destroy();
let cleanupOnError;
try {
delete slider.dataset.customBound;
delete slider.dataset.customHeroReady;
const track = slider.querySelector('[data-custom-hero-track]');
const slides = track ? Array.from(track.children).filter(function (slide) {
return slide.matches('.custom-hero-banner__slide') && !slide.hasAttribute('data-custom-hero-clone');
}) : [];
if (!track || slides.length === 0) return;
const dots = Array.from(slider.querySelectorAll('[data-custom-hero-dot]'));
const section = slider.closest('.shopify-section');
const fixedText = slider.querySelector('[data-custom-hero-fixed-text]');
const textPanels = slides.map(function (slide) { return slide.querySelector('.custom-hero-banner__content-wrap'); });
const panelStyles = textPanels.map(function (panel) { return panel?.getAttribute('style'); });
const signatures = textPanels.map(function (panel) { return panel?.innerHTML.replace(/\s+/g, ' ').trim(); });
const controller = new AbortController();
const signal = controller.signal;
const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
const desktop = window.matchMedia('(min-width: 768px)');
const interval = Math.max(1000, Number(slider.dataset.autoplayInterval) || 5000);
const imageDuration = Math.max(0, Number(slider.dataset.imageDuration) || 600);
const autoplay = slider.dataset.autoplay === 'true';
const pauseOnHover = slider.dataset.pauseOnHover === 'true';
const resumeAfterNavigation = slider.dataset.resumeAfterNavigation !== 'false';
const sharedText = slider.dataset.sharedText === 'true';
let activeIndex = 0;
let activeTextIndex = -1;
let fixedLayout = false;
let timer;
let scrollTimer;
let animationFrame;
let imageMoving = false;
let loopClone = null;
let savedSnap = '';
let savedBehavior = '';
let pointerStart = null;
let hovering = false;
let interacting = false;
let manuallyPaused = false;
let editorSelected = false;
let destroyed = false;
let resize;
let measuredWidth = -1;
let measuredHeight = -1;

  function stop() {
    window.clearTimeout(timer);
    timer = undefined;
  }

  function schedule() {
    stop();
    const focused = document.activeElement;
    if (destroyed || track.clientWidth < 1 || slides.length < 2 || !autoplay || motion.matches || imageMoving || document.hidden || hovering || interacting || manuallyPaused || editorSelected || (slider.contains(focused) && !focused.matches('[data-custom-hero-dot], [data-custom-hero-prev], [data-custom-hero-next]'))) return;
    timer = window.setTimeout(function () { navigate(activeIndex + 1, false); }, interval);
  }

  function updateText(index, instant = false) {
    if (!fixedText) return;
    const desired = sharedText ? 0 : index;
    const textIndex = activeTextIndex >= 0 && signatures[activeTextIndex] === signatures[desired] ? activeTextIndex : desired;
    if (textIndex === activeTextIndex && !instant) return;
    activeTextIndex = textIndex;
    fixedText.style.setProperty('--custom-text-duration', instant || motion.matches ? '0ms' : `${Number(slider.dataset.textDuration) || 300}ms`);
    textPanels.forEach(function (panel, panelIndex) {
      if (!panel) return;
      const current = !fixedLayout || panelIndex === textIndex;
      panel.classList.toggle('is-active', current && fixedLayout);
      panel.inert = !current;
      if (fixedLayout) panel.setAttribute('aria-hidden', current ? 'false' : 'true');
      else panel.removeAttribute('aria-hidden');
    });
  }

  function setActive(index, instant = false) {
    activeIndex = Math.max(0, Math.min(slides.length - 1, index));
    dots.forEach(function (dot, dotIndex) { dot.setAttribute('aria-current', dotIndex === activeIndex ? 'true' : 'false'); });
    slides.forEach(function (slide, slideIndex) {
      slide.inert = slideIndex !== activeIndex;
      slide.setAttribute('aria-hidden', slideIndex === activeIndex ? 'false' : 'true');
    });
    updateText(activeIndex, instant);
  }

  function offsetTo(slide) {
    const rect = slide.getBoundingClientRect();
    const bounds = track.getBoundingClientRect();
    return window.getComputedStyle(track).direction === 'rtl' ? rect.right - bounds.right : rect.left - bounds.left;
  }

  function jumpTo(slide) {
    track.scrollTo({ left: track.scrollLeft + offsetTo(slide), behavior: 'instant' });
  }

  function syncActive() {
    if (imageMoving) return;
    let nearest = 0;
    let distance = Infinity;
    slides.forEach(function (slide, index) {
      const offset = Math.abs(offsetTo(slide));
      if (offset < distance) { nearest = index; distance = offset; }
    });
    setActive(nearest);
  }

  function cancelImageAnimation(align = false) {
    if (animationFrame !== undefined) window.cancelAnimationFrame(animationFrame);
    animationFrame = undefined;
    const hadClone = !!loopClone;
    if (loopClone) { loopClone.remove(); loopClone = null; }
    if (imageMoving) {
      if (align || hadClone) jumpTo(slides[activeIndex]);
      track.style.scrollSnapType = savedSnap;
      track.style.scrollBehavior = savedBehavior;
    }
    imageMoving = false;
  }

  function moveImage(index, rawIndex, instant) {
    cancelImageAnimation();
    stop();
    if (instant || motion.matches || imageDuration === 0) {
      jumpTo(slides[index]);
      schedule();
      return;
    }
    savedSnap = track.style.scrollSnapType;
    savedBehavior = track.style.scrollBehavior;
    track.style.scrollSnapType = 'none';
    track.style.scrollBehavior = 'auto';
    imageMoving = true;
    let target = slides[index];
    if (rawIndex >= slides.length || rawIndex < 0) {
      const current = slides[rawIndex < 0 ? 0 : slides.length - 1];
      loopClone = target.cloneNode(true);
      loopClone.setAttribute('data-custom-hero-clone', 'true');
      loopClone.inert = true;
      loopClone.setAttribute('aria-hidden', 'true');
      loopClone.removeAttribute('data-shopify-editor-block');
      loopClone.removeAttribute('data-custom-hero-block');
      loopClone.querySelectorAll('[id]').forEach(function (node) { node.removeAttribute('id'); });
      if (rawIndex < 0) track.prepend(loopClone);
      else track.append(loopClone);
      jumpTo(current);
      target = loopClone;
    }
    const from = track.scrollLeft;
    const delta = offsetTo(target);
    const started = window.performance.now();
    function frame(now) {
      if (destroyed) return;
      const progress = Math.min(1, (now - started) / imageDuration);
      const eased = progress < .5 ? 4 * progress * progress * progress : 1 - Math.pow(-2 * progress + 2, 3) / 2;
      track.scrollTo({ left: from + delta * eased, behavior: 'instant' });
      if (progress < 1) animationFrame = window.requestAnimationFrame(frame);
      else {
        animationFrame = undefined;
        if (loopClone) { loopClone.remove(); loopClone = null; }
        jumpTo(slides[index]);
        track.style.scrollSnapType = savedSnap;
        track.style.scrollBehavior = savedBehavior;
        imageMoving = false;
        schedule();
      }
    }
    animationFrame = window.requestAnimationFrame(frame);
  }

  function manualNavigation() {
    manuallyPaused = !resumeAfterNavigation;
    schedule();
  }

  function navigate(rawIndex, manual, instant = false) {
    cancelImageAnimation();
    const index = (rawIndex + slides.length) % slides.length;
    setActive(index, instant);
    if (manual) manuallyPaused = !resumeAfterNavigation;
    moveImage(index, rawIndex, instant);
  }

  function configureLayout() {
    if (!fixedText) return;
    cancelImageAnimation(true);
    fixedLayout = (desktop.matches ? slider.dataset.layoutDesktop : slider.dataset.layoutMobile) === 'image_only';
    slider.dataset.fixedLayout = String(fixedLayout);
    fixedText.hidden = !fixedLayout;
    fixedText.style.cssText = slides[0].style.cssText;
    slider.style.setProperty('--custom-fixed-height-mobile', slides[0].style.getPropertyValue('--custom-text-panel-height-m') || '56%');
    const panelWidth = Math.max(1, Math.min(99, parseFloat(slides[0].style.getPropertyValue('--custom-text-panel-width-d')) || 43));
    slider.style.setProperty('--custom-fixed-panel-width', `${panelWidth}%`);
    slider.style.setProperty('--custom-fixed-media-width', `${10000 / (100 - panelWidth)}%`);
    textPanels.forEach(function (panel, index) {
      if (!panel) return;
      if (fixedLayout) {
        panel.style.cssText = slides[index].style.cssText;
        ['--custom-text-panel-width-d', '--custom-text-panel-height-m', '--custom-text-panel-bg-d', '--custom-text-panel-bg-m'].forEach(function (property) { panel.style.removeProperty(property); });
        ['--custom-content-offset-x-d', '--custom-content-offset-y-d', '--custom-content-offset-x-m', '--custom-content-offset-y-m'].forEach(function (property) { panel.style.setProperty(property, slides[0].style.getPropertyValue(property) || '0px'); });
        const attributes = slides[index].getAttribute('data-shopify-editor-block');
        if (attributes) panel.setAttribute('data-shopify-editor-block', attributes);
        fixedText.append(panel);
      } else {
        if (panelStyles[index] === null) panel.removeAttribute('style');
        else panel.setAttribute('style', panelStyles[index]);
        panel.removeAttribute('data-shopify-editor-block');
        slides[index].append(panel);
      }
    });
    activeTextIndex = -1;
    setActive(activeIndex, true);
    jumpTo(slides[activeIndex]);
    schedule();
  }

  function destroy() {
    if (destroyed) return;
    destroyed = true;
    stop();
    cancelImageAnimation(true);
    window.clearTimeout(scrollTimer);
    resize?.disconnect();
    controller.abort();
    textPanels.forEach(function (panel, index) {
      if (!panel) return;
      if (panelStyles[index] === null) panel.removeAttribute('style');
      else panel.setAttribute('style', panelStyles[index]);
      panel.classList.remove('is-active');
      panel.removeAttribute('aria-hidden');
      panel.removeAttribute('data-shopify-editor-block');
      panel.inert = false;
      slides[index].append(panel);
    });
    slides.forEach(function (slide) { slide.inert = false; slide.removeAttribute('aria-hidden'); });
    if (fixedText) fixedText.hidden = true;
    slider.removeAttribute('data-fixed-layout');
    delete slider.dataset.customBound;
    delete slider.dataset.customHeroReady;
    heroInstances.delete(slider);
  }
  cleanupOnError = destroy;

  dots.forEach(function (dot, index) { dot.addEventListener('click', function () { navigate(index, true); }, { signal }); });
  slider.querySelector('[data-custom-hero-prev]')?.addEventListener('click', function () { navigate(activeIndex - 1, true); }, { signal });
  slider.querySelector('[data-custom-hero-next]')?.addEventListener('click', function () { navigate(activeIndex + 1, true); }, { signal });
  slider.addEventListener('pointerenter', function (event) {
    if (!pauseOnHover || event.pointerType === 'touch') return;
    hovering = true;
    stop();
  }, { signal });
  slider.addEventListener('pointermove', function (event) {
    if (!pauseOnHover || hovering || event.pointerType === 'touch') return;
    hovering = true;
    stop();
  }, { signal, passive: true });
  slider.addEventListener('pointerleave', function () { hovering = false; schedule(); }, { signal });
  slider.addEventListener('focusin', schedule, { signal });
  slider.addEventListener('focusout', function () { window.queueMicrotask(schedule); }, { signal });
  track.addEventListener('pointerdown', function (event) {
    cancelImageAnimation();
    interacting = true;
    pointerStart = { x: event.clientX, y: event.clientY, index: activeIndex };
    stop();
  }, { signal, passive: true });
  function finishInteraction(event) {
    if (!interacting) return;
    interacting = false;
    const origin = pointerStart;
    pointerStart = null;
    const dx = origin ? event.clientX - origin.x : 0;
    const dy = origin ? event.clientY - origin.y : 0;
    if (event.type !== 'pointercancel' && origin && Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.2 && Math.abs(track.scrollLeft - slides[origin.index].offsetLeft) < 2 && window.getComputedStyle(track).direction !== 'rtl') {
      navigate(origin.index + (dx < 0 ? 1 : -1), true);
    } else manualNavigation();
  }
  document.addEventListener('pointerup', finishInteraction, { signal, passive: true });
  document.addEventListener('pointercancel', finishInteraction, { signal, passive: true });
  track.addEventListener('wheel', function () { cancelImageAnimation(); manualNavigation(); }, { signal, passive: true });
  track.addEventListener('keydown', function (event) {
    if (['ArrowLeft', 'ArrowRight', 'Home', 'End', 'PageUp', 'PageDown'].includes(event.key)) manualNavigation();
  }, { signal });
  track.addEventListener('scroll', function () {
    if (imageMoving) return;
    stop();
    window.clearTimeout(scrollTimer);
    scrollTimer = window.setTimeout(function () { syncActive(); schedule(); }, 100);
  }, { signal, passive: true });
  document.addEventListener('visibilitychange', schedule, { signal });
  motion.addEventListener('change', function () {
    if (motion.matches) cancelImageAnimation(true);
    schedule();
  }, { signal });
  desktop.addEventListener('change', configureLayout, { signal });
  if (window.ResizeObserver) {
    resize = new ResizeObserver(function () {
      const width = track.clientWidth;
      const height = track.clientHeight;
      if (Math.abs(width - measuredWidth) < 1 && Math.abs(height - measuredHeight) < 1) return;
      measuredWidth = width;
      measuredHeight = height;
      if (width > 0) navigate(activeIndex, false, true);
    });
    resize.observe(track);
  } else {
    window.addEventListener('resize', function () { navigate(activeIndex, false, true); }, { signal });
  }
  document.addEventListener('shopify:block:select', function (event) {
    if (!section?.contains(event.target)) return;
    const selected = slides.findIndex(function (slide, index) { return slide === event.target || slide.contains(event.target) || textPanels[index]?.contains(event.target); });
    editorSelected = true;
    stop();
    if (selected !== -1) navigate(selected, false, true);
  }, { signal });
  document.addEventListener('shopify:block:deselect', function (event) {
    if (!section?.contains(event.target)) return;
    editorSelected = false;
    schedule();
  }, { signal });
  document.addEventListener('shopify:section:unload', function (event) {
    if (event.target === section || event.target === slider || event.target.contains?.(slider)) destroy();
  }, { signal });
  configureLayout();
  syncActive();
  schedule();
  slider.dataset.customBound = 'true';
  slider.dataset.customHeroReady = 'fixed-text-v2';
  heroInstances.set(slider, { version: 'fixed-text-v2', destroy });
  } catch (error) {
    if (cleanupOnError) cleanupOnError();
    else {
      delete slider.dataset.customBound;
      delete slider.dataset.customHeroReady;
    }
    console.error('Matrix hero slider initialization failed', error);
  }
});

}

function bindHeroLinks(root) {
root.querySelectorAll('[data-custom-hero-slider] .custom-hero-banner__button[href]').forEach(function (link) {
if (link.dataset.customHeroLinkBound === 'true') return;
link.dataset.customHeroLinkBound = 'true';

  link.addEventListener('click', function (event) {
    const isPrimaryClick = event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
    if (!isPrimaryClick || !window.matchMedia('(max-width: 1024px)').matches) return;

    /*
     * The mobile toolbar/menu uses delegated click handlers.  Keep a hero
     * CTA tap inside the hero and navigate explicitly so it cannot also
     * be interpreted as a request to open the mobile menu.
     */
    event.preventDefault();
    event.stopImmediatePropagation();

    document.querySelectorAll('.custom-mobile-menu-toggle[id]').forEach(function (menuToggle) {
      if (!menuToggle.checked) return;
      menuToggle.checked = false;
      menuToggle.dispatchEvent(new Event('change', { bubbles: true }));
    });

    window.location.assign(link.href);
  }, true);
});

}

function initialize(root) {
bindHeroSliders(root || document);
bindFastInteractions();
applyAudience();
bindRailButtons(root || document);
bindComparisons(root || document);
bindHeroLinks(root || document);
}

if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', function () { initialize(document); });
} else {
initialize(document);
}

document.addEventListener('shopify:section', function (event) {
initialize(event.target);
});
})();